import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";

export default function NoAccess({ title = "You don't have access", message = "This area is limited to firm administrators. If you think this is a mistake, ask your firm admin." }) {
  const nav = useNavigate();
  return (
    <div className="w-full min-h-[60vh] flex items-center justify-center px-6 py-16 fade-up" data-testid="no-access">
      <div className="max-w-md text-center">
        <div className="w-14 h-14 rounded-2xl bg-[#B91C1C]/12 border border-[#B91C1C]/30 flex items-center justify-center mx-auto mb-5">
          <ShieldAlert size={26} className="text-[#F08A8A]" />
        </div>
        <h1 className="font-editorial text-2xl tracking-tight mb-2">{title}</h1>
        <p className="text-[14px] text-muted-foreground leading-relaxed mb-6">{message}</p>
        <button onClick={() => nav("/")} data-testid="no-access-back" className="inline-flex items-center gap-1.5 text-[13px] px-4 py-2 rounded-lg bg-primary text-primary-foreground font-semibold lift">
          <ArrowLeft size={15} /> Back to my matters
        </button>
      </div>
    </div>
  );
}
